export const site = {
  name: "HealthVoitho",
  legalName: "HealthVoitho Technologies",
  group: "Esperer Group",
  tagline: "Intelligent healthtech in the cancer ecosystem.",
  description:
    "A research-oriented technology organisation in the Esperer Group. We develop intelligent systems for earlier, more accessible cancer care.",
  url: "https://www.healthvoitho.com",
} as const;

export const navLinks = [
  { href: "/science", label: "Science" },
  { href: "/partnerships", label: "Partnerships" },
  { href: "/people", label: "People" },
] as const;

export const workLinks = [
  {
    href: "/chronic-pain-relief",
    label: "aVNS Technology",
    image: "/media/chronic-pain-neck-relief-v4.png",
    imageAlt: "A man holding his neck while experiencing chronic pain",
    imageClassName: "object-cover object-[68%_center]",
  },
  {
    href: "/salt-lick",
    label: "Salt Lick",
    image: "/media/saltlick.jpeg",
    imageAlt: "Salt Lick Healthcare logo",
    imageClassName: "object-contain p-3",
  },
  {
    href: "/nutra-iq",
    label: "NIQ",
    image: "/media/NIQ_Logo_HighRes_Transparent.png",
    imageAlt: "Nutra-IQ logo",
    imageClassName: "object-contain p-4",
  },
  {
    href: "/vitaliq",
    label: "VitalIQ",
    image: "/media/VitalIQ_Logo_HighRes_Transparent.png",
    imageAlt: "VitalIQ logo",
    imageClassName: "object-contain p-4",
  },
  {
    href: "/vitalz-pro",
    label: "VitalZ-Pro®",
    image: "/media/vitalz-pro/vitalz-pro-hero.png",
    imageAlt: "VitalZ-Pro portable diagnostic system",
    imageClassName: "object-cover object-[68%_center]",
  },
] as const;

export const contactCta = {
  href: "/contact",
  label: "Contact",
} as const;

export const groupCta = {
  href: "https://espererworld.com/",
  label: "Visit Group Site",
} as const;
